import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { User, UserDetails } from 'src/app/shared/models/auth/user';
import { LoggedUserSuccess } from './action';


export const AuthFeatureKey = 'auth';

export interface AuthState {
    user: UserDetails[];
    errors: string;
}

const InitialState: AuthState = {
    user: [],
    errors: ''
};

export const AuthReducer = createReducer(
    InitialState,
    on(LoggedUserSuccess, (state, { user }) => ({
        ...state,
        user,
        errors: ''
    }))
    );

const AuthSelector = createFeatureSelector<AuthState>(AuthFeatureKey);
export const GetUser = createSelector(
    AuthSelector,
    (state: AuthState) => {
        return state.user;
    }
);

// tslint:disable-next-line: typedef
export function reducer(state: AuthState | undefined, action: Action) {
    return AuthReducer(state, action);
}
